<template>
    <div :class="{'form-group':true, 'has-error': hasError }">
        <label v-if="label">{{ label }}</label>
        <slot></slot>
        <template v-if="errorMessage && hasError">
            <div v-for="(msg, error) in errorMessages" :key="msg">
                <label class="error" v-if="field[error] !== undefined && !field[error]">{{ fill(msg, error) }}</label>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        name: {
            type: String
        },
        label: {
            type: String
        },
        bag: {
            type: Object
        },
        showMessage: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            errorMessages: {
                required: 'This field is required.',
                email: 'Invalid email address.',
                sameAsPassword: 'Passwords must be identical.',
                minLength: 'Must be at least (:min) characters.',
                numeric: 'Must be at valid number.'
            }
        }  
    },
    methods: {
        fill: function(message, error) {
            switch(error) {
                case 'minLength':
                    return message.replace(':min', this.field.$params.minLength.min);
            }

            return message;
        }
    },
    computed: {
        /*
        * Nested components such as modals don't have the correct parent set
        * so for now we must pass in the vuelidate object as bag and set a consistent
        * property to check against (using val instead of validator to avoid collision)
        */
        $bag: function() {
            if (this.$parent.$v) {
                return this.$parent.$v;
            } else if (this.$parent.$parent.$v) {
                return this.$parent.$parent.$v;
            } else if (this.bag) {
                return this.bag;
            } else {
                return null;
            }
        },
        hasError: function() {
            return this.field && this.field.$error;
        },
        field: function() {
            if (!this.name || !this.$bag) {
                return false;
            }
            
            let segments = this.name.split('.');
            let value = this.$bag[segments[0]];
            
            for (let i=1; i < segments.length; i++) {
                if (!isNaN(segments[i])) {
                    value = value.$each[segments[i]];
                } else if (value) {
                    value = value[segments[i]];
                }
            }
            
            return value;
        }
    }
}
</script>